<template>
  <vx-card>
    <div class="vx-row">
      <div class="vx-col w-full mb-4" v-if="detail !== null">
        <div class="flex justify-end">
          <strong class="mr-4">Status</strong>
          <strong :class="status === 0 ? 'text-danger' : 'text-success'">{{
            status === 0 ? "Belum Disetujui" : "Disetujui"
          }}</strong>
        </div>
      </div>
      <div class="vx-col w-full mb-6">
        <p class="mb-2"><strong>Judul Campaign</strong></p>
        <vs-input
          name="name"
          class="w-full"
          v-model="name"
          v-validate="'required'"
          val-icon-success="icon-x"
          val-icon-pack="feather"
          :danger="errors.has('name')"
        />
        <!-- JUdul -->
        <span class="text-danger text-sm" v-show="errors.has('name')">{{
          errors.first("name")
        }}</span>
        <!-- / -->
      </div>
      <div class="vx-col w-full mb-8">
        <p class="mb-2"><strong>Slug</strong></p>
        <vs-input
          name="slug"
          class="w-full"
          v-model="slug"
          v-validate="'required'"
          val-icon-success="icon-x"
          val-icon-pack="feather"
          :disabled="true"
          :danger="errors.has('slug')"
        />
        <!-- JUdul -->
        <span class="text-danger text-sm" v-show="errors.has('slug')">{{
          errors.first("slug")
        }}</span>
        <!-- / -->
      </div>
      <div class="vx-col w-full mb-8" v-if="preview_file !== null">
        <div class="flex justify-center relative">
          <a
            href="#"
            @click.prevent="unhandleFile"
            class="absolute"
            style="top: 0; right: 0"
          >
            <feather-icon icon="XIcon" svgClasses="text-danger"></feather-icon>
          </a>
          <img
            :src="
              preview_file.includes('upload/')
                ? `${url.baseFl}/${preview_file}`
                : preview_file
            "
            alt="preview"
            class="w-full md:w-1/2 lg:w-1/3"
          />
        </div>
      </div>
      <div class="vx-col w-full md:w-1/2 mb-8">
        <p class="mb-2"><strong>Gambar Sampul</strong></p>
        <input type="file" class="hidden" ref="file" @change="handleFile" />
        <vs-button
          class="rounded-none"
          color="primary"
          @click.prevent="$refs.file.click()"
        >
          Pilih Gambar
        </vs-button>
        <!-- gambar sampul -->
        <span class="text-danger text-sm" v-show="errors.has('file')">{{
          errors.first("file")
        }}</span>
      </div>
      <div class="vx-col w-full md:w-1/2 mb-8">
        <p class="mb-2"><strong>Target Donasi</strong></p>
        <vs-input
          @keypress="onlyNumber"
          name="donasi"
          class="w-full"
          v-model="nominal"
          v-validate="'required'"
          val-icon-success="icon-x"
          val-icon-pack="feather"
          :danger="errors.has('donasi')"
        />
        <!-- Target donasi -->
        <span class="text-danger text-sm" v-show="errors.has('donasi')">{{
          errors.first("donasi")
        }}</span>
      </div>
      <div class="vx-col w-full md:w-1/2 mb-8">
        <p class="mb-2"><strong>Tanggal Mulai</strong></p>
        <flat-pickr
          class="w-full"
          :config="configFromdateTimePicker"
          v-model="mulai"
          name="mulai"
          placeholder="Tentukan Tanggal Mulai"
          @on-change="onFromChange"
          v-validate="'required'"
          :danger="errors.has('mulai')"
        />
        <!-- <vs-input
          type="date"
          name="mulai"
          class="w-full"
          v-model="mulai"
          v-validate="'required'"
          val-icon-success="icon-x"
          val-icon-pack="feather"
          :danger="errors.has('mulai')"
        /> -->
        <!-- tanggal mulai -->
        <span class="text-danger text-sm" v-show="errors.has('mulai')">{{
          errors.first("mulai")
        }}</span>
      </div>
      <div class="vx-col w-full md:w-1/2 mb-8">
        <p class="mb-2"><strong>Tanggal Selesai</strong></p>
        <!-- <vs-input
          type="date"
          name="selesai"
          class="w-full"
          v-model="selesai"
          v-validate="'required'"
          val-icon-success="icon-x"
          val-icon-pack="feather"
          :danger="errors.has('selesai')"
        /> -->
        <!-- <vs-input
          v-if="mulai === null"
          :disabled="true"
          class="w-full"
          placeholder="Tentukan Tanggal Selesai"
        /> -->
        <flat-pickr
          :disabled="mulai === null"
          class="w-full sidebar-input"
          :config="configTodateTimePicker"
          v-model="selesai"
          name="selesai"
          v-validate="'required'"
          placeholder="Tentukan Tanggal Selesai"
          @on-change="onToChange"
          :danger="errors.has('selesai')"
        />
        <!-- tanggal selesai -->
        <span class="text-danger text-sm" v-show="errors.has('selesai')">{{
          errors.first("selesai")
        }}</span>
      </div>
      <div class="vx-col w-full md:w-1/2 mb-8">
        <p class="mb-2"><strong>Kategori</strong></p>
        <v-select
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="kategori"
          class="w-full"
          v-model="kategori"
          :reduce="(v) => v.id"
          label="name"
          :options="kategoriOptions"
          placeholder="Pilih Kategori"
        />
        <span class="text-danger text-sm" v-show="errors.has('kategori')">{{
          errors.first("kategori")
        }}</span>
      </div>
      <div class="vx-col w-full md:w-1/2 mb-8">
        <p class="mb-2"><strong>Sub Kategori</strong></p>
        <v-select
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="subKategori"
          class="w-full"
          v-model="sub_id"
          :reduce="(v) => v.id"
          :options="subKategoriOptions"
          label="name"
          :disabled="kategori === null"
          placeholder="Pilih Sub-Kategori"
        />
        <span class="text-danger text-sm" v-show="errors.has('subKategori')">{{
          errors.first("subKategori")
        }}</span>
      </div>
      <div class="vx-col w-full mb-8">
        <p class="mb-2"><strong>Deskripsi</strong></p>
        <vue-editor
          class="w-full"
          v-model="deskripsi"
          name="deskripsi"
          v-validate="'required'"
        ></vue-editor>
        <!-- <vs-textarea
          class="w-full"
          v-model="deskripsi"
          name="deskripsi"
          v-validate="'required'"
          :danger="errors.has('deskripsi')"
        /> -->
        <span class="text-danger text-sm" v-show="errors.has('deskripsi')">{{
          errors.first("deskripsi")
        }}</span>
      </div>
      <div class="vx-col w-full mb-8">
        <p class="mb-2"><strong>RAB</strong></p>
        <vs-textarea
          class="w-full"
          v-model="rab"
          name="rab"
          v-validate="'required'"
          :danger="errors.has('rab')"
        />
        <span class="text-danger text-sm" v-show="errors.has('rab')">{{
          errors.first("rab")
        }}</span>
      </div>
      <div class="vx-col w-full mb-8">
        <p class="mb-2"><strong>Status Urgensi</strong></p>
        <v-select
          v-validate="'required'"
          data-vv-validate-on="blur"
          class="w-full"
          v-model="status_priority"
          :reduce="(v) => v.id"
          :options="priority"
          label="text"
          name="urgent"
          placeholder="Pilih Status Urgensi"
        />
        <span class="text-danger text-sm" v-show="errors.has('urgent')">{{
          errors.first("urgent")
        }}</span>
      </div>
      <vs-divider position="left"
        ><span class="text-lg text-black mb-16"
          ><strong>Lokasi Campaign</strong></span
        ></vs-divider
      >
      <div class="vx-col sm:w-full md:w-4/12 lg:w-4/12 mb-8">
        <p class="mb-2"><strong>Pilih Provinsi</strong></p>
        <v-select
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="provinsi"
          class="w-full"
          v-model="provinsi_id"
          :reduce="(v) => v.id"
          label="name"
          :options="provinsiList"
          placeholder="Pilih Provinsi"
        />
        <span class="text-danger text-sm" v-show="errors.has('provinsi')">{{
          errors.first("provinsi")
        }}</span>
      </div>
      <div class="vx-col sm:w-full md:w-4/12 lg:w-4/12 mb-8">
        <p class="mb-2"><strong>Pilih Kabupaten/Kota</strong></p>
        <v-select
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="kabkot"
          class="w-full"
          v-model="kabkot_id"
          :reduce="(v) => v.id"
          :options="kabKotList"
          label="name"
          :disabled="provinsi_id === null"
          placeholder="Pilih Kabupaten/Kota"
        />
        <span class="text-danger text-sm" v-show="errors.has('kabkot')">{{
          errors.first("kabkot")
        }}</span>
      </div>
      <div class="vx-col sm:w-full md:w-4/12 lg:w-4/12 mb-8">
        <p class="mb-2"><strong>Kecamatan</strong></p>
        <v-select
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="kecamatan"
          class="w-full"
          v-model="kecamatan_id"
          :reduce="(v) => v.id"
          :options="kecamatanList"
          label="name"
          :disabled="kabkot_id === null"
          placeholder="Pilih Kecamatan"
        />
        <span class="text-danger text-sm" v-show="errors.has('kecamatan')">{{
          errors.first("kabkot")
        }}</span>
      </div>
      <div class="vx-col w-full mb-8">
        <p class="mb-2"><strong>Alamat</strong></p>
        <vs-textarea
          class="w-full"
          v-model="alamat"
          name="alamat"
          v-validate="'required'"
          :danger="errors.has('alamat')"
        />
        <span class="text-danger text-sm" v-show="errors.has('alamat')">{{
          errors.first("alamat")
        }}</span>
      </div>
      <vs-divider position="left"
        ><span class="text-lg text-black mb-16"><strong>PIC</strong></span></vs-divider
      >
      <div class="vx-col w-full md:w-1/2 mb-8">
        <p class="mb-2"><strong>Nama PIC</strong></p>
        <vs-input
          name="namaPic"
          class="w-full"
          v-model="namaPic"
          v-validate="'required'"
          val-icon-success="icon-x"
          val-icon-pack="feather"
          :danger="errors.has('namaPic')"
        />
        <span class="text-danger text-sm" v-show="errors.has('namaPic')">{{
          errors.first("namaPic")
        }}</span>
      </div>
      <div class="vx-col w-full md:w-1/2 mb-8">
        <p class="mb-2"><strong>No.Telepon PIC</strong></p>
        <!-- <VuePhoneNumberInput
          default-country-code="ID"
          no-country-selector
          @update="noTelpPic = $event.e164"
          name="noTelpPic"
          :error="noTelpPic === '' || noTelpPic === null"
          v-model="noTelpPic"
          class="w-full"
        /> -->
        <vs-input
          name="noTelpPic"
          class="w-full"
          v-model="noTelpPic"
          v-validate="'required'"
          val-icon-success="icon-x"
          val-icon-pack="feather"
          @keypress="onlyNumber"
          :danger="errors.has('noTelpPic')"
        />
        <span class="text-danger text-sm" v-show="errors.has('noTelpPic')">{{
          errors.first("noTelpPic")
        }}</span>
      </div>
      <div class="vx-col w-full mb-8">
        <p class="mb-2"><strong>Alamat PIC</strong></p>
        <vs-textarea
          class="w-full"
          v-model="alamatPic"
          name="alamatPic"
          v-validate="'required'"
          :danger="errors.has('alamatPic')"
        />
        <span class="text-danger text-sm" v-show="errors.has('alamatPic')">{{
          errors.first("alamatPic")
        }}</span>
      </div>
      <vs-divider position="left"
        ><span class="text-lg text-black mb-16"
          ><strong>Video URL</strong></span
        ></vs-divider
      >
      <div class="vx-col w-full mb-8">
        <p class="mb-2"><strong>Masukan URL Video</strong></p>
        <vs-input
          class="w-full"
          v-model="videoUrl"
          placeholder="Masukan Link Video Dari Youtube atau Link Video MP4"
        />
      </div>
      <div class="vx-col w-full md:w-1/5 lg:w-1/6">
        <vs-button class="rounded-none w-full" color="primary" @click.prevent="submit">
          SUBMIT
        </vs-button>
      </div>
    </div>
  </vx-card>
</template>
<script>
import { VueEditor } from "vue2-editor";
import { Validator } from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import vSelect from "vue-select";
import url from "@/url.js";

const dict = {
  custom: {
    urgent: {
      required: "Harap isi urgensi campaign",
    },
    name: {
      required: "Harap isi judul campaign",
    },
    file: {
      required: "Harap pilih gambar sampul",
    },
    mulai: {
      required: "Harap isi tanggal mulai",
    },
    selesai: {
      required: "Harap isi tanggal selesai",
    },
    donasi: {
      required: "Harap isi target donasi",
    },
    rab: {
      required: "Harap isi RAB",
    },
    kategori: {
      required: "Harap isi Kategori",
    },
    subKategori: {
      required: "Harap isi Sub-Kategori",
    },
    provinsi: {
      required: "Harap isi Provinsi",
    },
    kabkot: {
      required: "Harap isi Kabupaten/Kota",
    },
    alamat: {
      required: "Harap isi Alamat",
    },
    namaPic: {
      required: "Harap isi Nama PIC",
    },
    noTelpPic: {
      required: "Harap isi No.Telepon PIC",
    },
    alamatPic: {
      required: "Harap isi Alamat PIC",
    },
    slug: {
      required: "Harap isi judul Campaign untuk mendapatkan Slug",
    },
    kecamatan: {
      required: "Harap isi Kecamatan",
    },
  },
};

// register custom messages
Validator.localize("en", dict);

export default {
  created() {
    this.$vs.loading.close();

    if (
      this.$store.state.campaign.kategoriList.length === 0 &&
      this.$store.state.campaign.subKategoriList.length === 0
    ) {
      this.getKategori();
      this.getSubKategori();
    } else {
      this.kategoriOptions = this.$store.state.campaign.kategoriList;
    }
  },
  methods: {
    onFromChange(selectedDates, dateStr) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
    },
    onToChange(selectedDates, dateStr) {
      this.$set(this.configFromdateTimePicker, "maxDate", dateStr);
    },
    getKategori() {
      this.$store.dispatch("campaign/getKatCampaign", {}).catch((e) => {
        if (e.response) {
          console.error(e.response.data.message);
          this.$vs.notify({
            position: "top-right",
            title: "Oops!",
            text: e.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      });
    },
    unhandleFile() {
      this.preview_file = null;
      this.file = null;
      this.$refs.file.value = "";
    },
    handleFile(e) {
      const objFile = e.target.files[0];

      if (!["image/jpeg", "image/png", "image/gif"].includes(objFile.type)) {
        e.target.value = "";
        this.$vs.notify({
          title: "Pemilihan gambar sampul gagal",
          text: "Selain file gambar tidak boleh",
          color: "warning",
          position: "top-right",
        });

        this.preview_file = null;
        this.file = null;

        return false;
      }

      // Create preview_file
      this.preview_file = URL.createObjectURL(objFile);
      this.file = objFile;
      console.log("file", this.file);
    },
    submit() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          // if (this.kategori == null || this.sub_id == null) {
          //   this.$vs.notify({
          //     title: "Harap kategori & sub kategori",
          //     text: "",
          //     color: "warning",
          //     position: "top-right",
          //   });

          //   return false;
          // }

          if (this.donasi == "0") {
            this.$vs.notify({
              title: "Harga donasi harus lebih dari 0",
              text: "",
              color: "warning",
              position: "top-right",
            });

            return false;
          }

          if (this.file == null && this.preview_file == null) {
            this.$vs.notify({
              title: "Harap pilih gambar sampul",
              text: "",
              color: "warning",
              position: "top-right",
            });

            return false;
          }

          if (this.deskripsi == null || this.deskripsi === "") {
            this.$vs.notify({
              title: "Harap isi deskripsi",
              text: "",
              color: "warning",
              position: "top-right",
            });

            return false;
          }

          this.$vs.loading();
          let id = {};
          let payload = {
            file: this.preview_file,
            provinsi_id: this.provinsi_id,
            kecamatan_id: this.kecamatan_id,
            name: this.name,
            donasi: this.donasi.replaceAll(".", ""),
            mulai: this.mulai,
            selesai: this.selesai,
            rab: this.rab,
            deskripsi: this.deskripsi,
            user_id:
              this.detail !== null
                ? this.detail.user
                  ? this.detail.user.id
                  : this.profile.id
                : this.profile.id,
            sub_id: this.sub_id,
            kat_id: this.kategori,
            status: this.profile.level.id !== 2 ? 0 : this.status,
            status_priority: this.status_priority,
            kabkot_id: this.kabkot_id,
            alamat: this.alamat,
            nama_pic: this.namaPic,
            no_telp_pic: this.noTelpPic,
            alamat_pic: this.alamatPic,
            slug: this.slug,
            video_url: this.videoUrl !== "" ? this.videoUrl : "-",
          };

          if (this.detail !== null) {
            id = {
              id: this.detail.id,
            };
          }

          // let video = {};
          // if (this.videoUrl !== "") {
          //   video = {
          //     video_url: this.videoUrl,
          //   };
          // }

          if (this.file !== null) {
            this.$store
              .dispatch("file/addFile", this.file)
              .then((result) => {
                this.preview_file = result.link;

                this.$store
                  .dispatch("campaign/cudCampaign", [
                    {
                      ...payload,
                      ...id,
                      file: this.preview_file,
                    },
                  ])
                  .then(() => {
                    this.$vs.loading.close();
                    this.$router.push("/dashboard/campaign");
                  })
                  .catch((e) => {
                    this.$vs.loading.close();
                    if (e.response) console.error(e.response);
                    this.$vs.notify({
                      title: "Oops",
                      text: e.response.data.message,
                      color: "warning",
                      position: "top-right",
                    });

                    return false;
                  });
              })
              .catch((e) => {
                this.$vs.loading.close();
                if (e.response) console.error(e.response);
                this.$vs.notify({
                  title: "Oops",
                  text: e.response.data.message,
                  color: "warning",
                  position: "top-right",
                });

                return false;
              });
          } else {
            if (this.preview_file !== null) {
              this.$store
                .dispatch("campaign/cudCampaign", [
                  { ...payload, ...id, file: this.preview_file },
                ])
                .then(() => {
                  this.$vs.loading.close();
                  this.$router.push("/dashboard/campaign");
                })
                .catch((e) => {
                  this.$vs.loading.close();
                  if (e.response) console.error(e.response);
                  this.$vs.notify({
                    title: "Oops",
                    text: e.response.data.message,
                    color: "warning",
                    position: "top-right",
                  });

                  return false;
                });
            } else {
              this.$vs.notify({
                title: "Harap pilih gambar sampul",
                text: "",
                color: "warning",
                position: "top-right",
              });

              return false;
            }
          }
        }
      });
    },
    getDataDetail(id) {
      this.$vs.loading({
        color: "primary",
      });
      this.$store
        .dispatch("campaign/getDetailCampaign", id)
        .then((v) => {
          this.detail = v;
          this.fillDetail(v);
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    fillDetail(val) {
      this.name = val.name;
      this.nominal = val.donasi.toString();
      this.mulai = val.mulai;
      this.selesai = val.selesai;
      this.rab = val.rab;
      this.kecamatan_id = val.kecamatan ? val.kecamatan.id : null;
      this.deskripsi = this.richtTextFormat(val.deskripsi);
      this.kategori = val.sub_kategori.kategori ? val.sub_kategori.kategori.id : null;
      this.sub_id = val.sub_kategori ? val.sub_kategori.id : null;
      this.preview_file = this.getPathFoto(val);
      this.status_priority = val.status_priority;
      this.status = val.status;
      this.provinsi_id = val.kecamatan.kabkot.provinsi
        ? val.kecamatan.kabkot.provinsi.id
        : null;
      this.kabkot_id = val.kecamatan.kabkot ? val.kecamatan.kabkot.id : null;
      this.alamat = val.alamat;
      this.namaPic = val.nama_pic;
      this.noTelpPic = val.no_telp_pic;
      this.alamatPic = val.alamat_pic;
      this.videoUrl = val.video_url;
      this.slug = val.slug;
    },
    getKecamatan() {
      this.$store
        .dispatch("wilayah/getKecamatan", { kabkot_id: this.kabkot_id })
        .then((v) => {
          this.kecamatanList = v.data;
          if (this.kecamatanList.length !== 0 && this.kecamatan_id !== null) {
            if (
              this.kecamatanList.find((v) => v.id === this.kecamatan_id) === undefined
            ) {
              this.kecamatan_id = null;
            }
          }
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getSubKategori() {
      this.$store.dispatch("campaign/getSubKatCampaign", {}).catch((e) => {
        if (e.response) {
          console.error(e.response.data.message);
          this.$vs.notify({
            position: "top-right",
            title: "Oops!",
            text: e.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      });
    },
  },
  watch: {
    kategori() {
      if (this.kategori !== null) {
        this.subKategoriOptions = this.$store.getters["campaign/filterSubKategori"](
          this.kategori
        );
        if (this.sub_id !== null) {
          if (this.subKategoriOptions.find((v) => v.id === this.sub_id) === undefined) {
            this.sub_id = null;
          }
        }
      } else {
        this.sub_id = null;
      }
    },
    kategoriList() {
      if (this.$store.state.campaign.kategoriList.length !== 0) {
        this.kategoriOptions = this.$store.state.campaign.kategoriList;
      }
    },
    provinsi_id() {
      if (this.provinsi_id !== null) {
        this.kabKotList = this.$store.getters["wilayah/getFilteredKabKot"](
          this.provinsi_id
        );
        if (this.kabkot_id !== null) {
          if (this.kabKotList.find((v) => v.id === this.kabkot_id) === undefined) {
            this.kabkot_id = null;
          }
        }
      } else {
        this.kabkot_id = null;
      }
    },
    name() {
      if (this.name !== "" || this.name !== null) {
        this.slugFormatter = this.name;
      }
    },
    kabkot_id() {
      if (this.kabkot_id !== null) {
        this.getKecamatan(this.kabkot_id);
      } else {
        this.kecamatan_id = null;
      }
    },
  },
  components: {
    VuePhoneNumberInput,
    VueEditor,
    vSelect,
    flatPickr,
  },
  mounted() {
    this.provinsiList = this.$store.state.wilayah.provinsiList;

    if (this.$route.params.id !== undefined) {
      // if (this.$store.state.campaign.campaign.length !== 0) {
      //   this.detail = this.$store.getters["campaign/detail"](this.$route.params.id);
      //   this.fillDetail(this.detail);
      // } else {
      //   this.getDataDetail(this.$route.params.id);
      // }
      this.getDataDetail(this.$route.params.id);
    }

    if (this.profile.level.id === 2) {
      this.status = 1;
    }
  },
  computed: {
    profile() {
      return this.$store.state.auth.profileAccess.profile;
    },
    nominal: {
      get() {
        return this.formatRupiah(this.donasi);
      },
      set(val) {
        // Do something with the val here...
        this.donasi = val;
      },
    },
    kategoriList() {
      return this.$store.state.campaign.kategoriList;
    },
    slugFormatter: {
      get() {
        return this.slug;
      },
      set(v) {
        this.slug = v.replaceAll(" ", "-").toLowerCase();
      },
    },
  },
  data: () => ({
    url,
    preview_file: null,
    name: null,
    file: null,
    donasi: null,
    mulai: null,
    selesai: null,
    deskripsi: null,
    status_priority: null,
    rab: null,
    sub_id: null,
    kategori: null,
    kategoriOptions: [],
    subKategoriOptions: [],
    status: 0,
    detail: null,
    provinsi_id: null,
    kabkot_id: null,
    kecamatan_id: null,
    provinsiList: [],
    kabKotList: [],
    kecamatanList: [],
    alamat: "",
    namaPic: "",
    noTelpPic: "",
    alamatPic: "",
    videoUrl: "",
    slug: "",
    configFromdateTimePicker: {
      minDate: null,
      maxDate: new Date("2100-12-30"),
      enableSeconds: false,
      enableTime: false,
      time_24hr: true,
      dateFormat: "Y-m-d",
    },
    configTodateTimePicker: {
      minDate: null,
      maxDate: new Date("2100-12-30"),
      enableSeconds: false,
      enableTime: false,
      time_24hr: true,
      dateFormat: "Y-m-d",
    },
    priority: [
      {
        id: 0,
        text: "Normal",
      },
      {
        id: 1,
        text: "Darurat",
      },
    ],
    editorOptions: {
      modules: {
        toolbar: {
          container: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ["clean"],
            ["image"],
          ],
        },
      },
    },
  }),
};
</script>

<style lang="scss" scoped>
.font-textarea {
  font-family: "Times New Roman", Times, serif;
  color: rgb(58, 58, 58);
}
</style>
